import React, { useMemo, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Greetings from '../module/dashboard/greetings/Greetings';
import UpgradeModal from '../components/UpgradeModal';
import '../assets/css/dashboard.css';

const Dashboard = () => {
  const { currentFarm, user } = useAuth();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  // Begrüßung nach Tageszeit
  const greeting = useMemo(() => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Guten Morgen';
    if (hour < 18) return 'Guten Tag';
    return 'Guten Abend';
  }, []);



  // Überprüfen, ob Basic-Mitglied
  const isBasicMember = currentFarm?.membership === 'basic';

  return (
    <div className="dashboard-container">
      <Greetings greeting={greeting} farmName="Hauke-Christian" />
      
      {/* Basic Paket Hinweis */}
      {isBasicMember && (
        <div className="basic-package-banner">
          <div className="basic-package-content">
            <div className="basic-package-icon">
              <i className="material-icons">star_border</i>
            </div>
            <div className="basic-package-text">
              <h3>Basic Paket aktiv</h3>
              <p>Erweitern Sie Ihre Reichweite mit unserem Plus- oder Premium-Paket</p>
            </div>
            <button 
              className="upgrade-btn"
              onClick={() => setShowUpgradeModal(true)}
            >
              Jetzt upgraden
            </button>
          </div>
        </div>
      )}


      {/* Upgrade Modal */}
      <UpgradeModal 
        isOpen={showUpgradeModal} 
        onClose={() => setShowUpgradeModal(false)} 
      />
    </div>
  );
};

export default Dashboard;